export const atGallery = [
  {
    id: 1,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2FM645426.jpg?alt=media&token=707a3629-aecd-4dc9-af9b-8447c4f0fc2f",
  },
  {
    id: 83866,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2Fbigbend001.jpg?alt=media&token=ff70fced-ce24-4694-9b3a-87e7999a7a14",
  },
  {
    id: 2,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2FM645424.jpg?alt=media&token=3974ba34-39b4-45ac-9a7e-b6f3e1db3878",
  },
  {
    id: 3,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2F001176.jpg?alt=media&token=962a38b1-a37d-4908-948c-39e5df7109ff",
  },
  {
    id: 4,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2F001277e.jpg?alt=media&token=1de64b9b-d939-43e5-a468-f670f59c8350",
  },
  {
    id: 5,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2F001140.jpg?alt=media&token=a037e926-a7f4-470a-ad2b-5175fe14b999",
  },
  {
    id: 6,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2Fimg20200519.jpg?alt=media&token=f633a4da-ce53-46c6-a223-a7be339456e1",
  },
  {
    id: 7,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2Fimg20201012_19165973.jpg?alt=media&token=a6f3516b-3bb5-4a00-861a-ee5d2069ae39",
  },
  {
    id: 8,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2Fimg20201025_18444765.jpg?alt=media&token=4ed39311-8b47-4ab4-a61c-e19ee7423bd5",
  },
  {
    id: 8,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2F001213.jpg?alt=media&token=4828091e-08e5-466a-a393-e51a39fe3d32",
  },
  {
    id: 3229821,
    desc: "",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/acrossTexas%2Faustin0105.jpg?alt=media&token=e21e7f23-af0e-4a72-a3d9-cbcb6d49d2c1",
  },
];

export const Gleamin = [
  {
    id: 3121971,
    desc: "Apache Meat Market — Del Rio, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FApacheMeatMarket_2018.jpg?alt=media&token=8535a989-0440-4daf-8903-14290e7118dc",
  },
  {
    id: 328765,
    desc: "Drive Thru Postal — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FDriveThuPostal_2021.jpg?alt=media&token=22f9dd63-7232-49fd-a5aa-c5a79fff7872",
  },
  {
    id: 323221,
    desc: "Native — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FNative_2020.jpg?alt=media&token=c132ec44-dbb2-47c3-ac70-8c1a0704f4fe",
  },

  {
    id: 364121,
    desc: "Arby's — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FArby's_2018.jpg?alt=media&token=b21833bc-4818-4201-8f34-7be98a366a4e",
  },
  {
    id: 387872,
    desc: "Mission Drive-In — San Antonio, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FMissionDriveIn_2019.jpg?alt=media&token=a29c68a5-5b47-430c-97a4-d81dc0c22495",
  },
  {
    id: 33787,
    desc: "Thunder Cloud — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FThunderCloud_2018.jpg?alt=media&token=0967259e-cf00-4efe-83a1-2900ebb9ff5e",
  },
  {
    id: 313321,
    desc: "I Luv Video — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FILuvVideo_2021.jpg?alt=media&token=f824ed94-be1f-4a97-b28b-7f5d364a6e80",
  },

  {
    id: 38785,
    desc: "Relax Inn — San Antonio, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FRelaxInn_2021.jpg?alt=media&token=3649becb-7566-4c57-b2fb-87c020ae3f2b",
  },
  {
    id: 387823,
    desc: "flaming Automotive — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FFlamingAuto_2018.jpg?alt=media&token=43b5bc3e-2928-4d45-a654-b7c1c611d538",
  },
  {
    id: 38782,
    desc: "",
    photo: "",
  },
  {
    id: 387297,
    desc: "",
    photo: "",
  },
  {
    id: 38275,
    desc: "",
    photo: "",
  },
  {
    id: 38727,
    desc: "",
    photo: "",
  },
  {
    id: 332238,
    desc: "",
    photo: "",
  },
  {
    id: 343845,
    desc: "",
    photo: "",
  },
  {
    id: 3833428,
    desc: "",
    photo: "",
  },
  {
    id: 383437,
    desc: "",
    photo: "",
  },
  {
    id: 387382,
    desc: "",
    photo: "",
  },
];

export const PrintStoreImages = [
  {
    id: 311,
    title: "I Luv Video — Austin, Texas",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/ogphoto-app.firebasestorage.app/o/portfolio-assets%2FILuvVideo_2021.jpg?alt=media&token=f824ed94-be1f-4a97-b28b-7f5d364a6e80",

    print: {
      edition: "Open edition",
      production: "Made to order",

      sizes: {
        "12 × 16": 150,
        "16 × 20": 250,
        "20 × 24": 350,
        "24 × 30": 500,
      },

      papers: {
        "Hahnemühle Photo Rag": 0,
        "Hahnemühle FineArt Baryta": 50,
      },

      frames: {
        Unframed: 0,

        "Black Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },

        "Natural Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },
      },
    },
  },

  {
    id: 32,
    title: "Untitled",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/dillo-dash.firebasestorage.app/o/ogarcia_photo-portfolio%2F001326.jpg?alt=media&token=834ef49a-5970-4c34-a275-e73c3db1907a",

    print: {
      edition: "Open edition",
      production: "Made to order",

      sizes: {
        "12 × 16": 150,
        "16 × 20": 250,
        "20 × 24": 350,
        "24 × 30": 500,
      },

      papers: {
        "Hahnemühle Photo Rag": 0,
        "Hahnemühle FineArt Baryta": 50,
      },

      frames: {
        Unframed: 0,

        "Black Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },

        "Natural Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },
      },
    },
  },

  {
    id: 3121971,
    title: "Hello",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/gleamin%2FM645414.jpg?alt=media&token=d4943d23-3a8c-4367-86d5-c1210d629fd9",

    print: {
      edition: "Open edition",
      production: "Made to order",

      sizes: {
        "12 × 16": 175,
        "16 × 20": 275,
        "20 × 24": 375,
        "24 × 30": 525,
      },

      papers: {
        "Hahnemühle Photo Rag": 0,
        "Hahnemühle FineArt Baryta": 50,
      },

      frames: {
        Unframed: 0,

        "Black Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },

        "Natural Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },
      },
    },
  },

  {
    id: 3112121,
    title: "Untitled",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/gleamin%2FM645519.jpg?alt=media&token=0697a878-9b42-4ed9-891b-1bbf51173d0c",

    print: {
      edition: "Open edition",
      production: "Made to order",

      sizes: {
        "12 × 16": 175,
        "16 × 20": 275,
        "20 × 24": 375,
        "24 × 30": 525,
      },

      papers: {
        "Hahnemühle Photo Rag": 0,
        "Hahnemühle FineArt Baryta": 50,
      },

      frames: {
        Unframed: 0,

        "Black Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },

        "Natural Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },
      },
    },
  },

  {
    id: 32221,
    title: "Untitled",
    photo:
      "https://firebasestorage.googleapis.com/v0/b/octavio-photoportfolio.appspot.com/o/gleamin%2FClassicInn.jpg?alt=media&token=efa30f9f-b2bd-4e17-8993-ff6c16bdfa0f",

    print: {
      edition: "Open edition",
      production: "Made to order",

      sizes: {
        "12 × 16": 150,
        "16 × 20": 250,
        "20 × 24": 350,
        "24 × 30": 500,
      },

      papers: {
        "Hahnemühle Photo Rag": 0,
        "Hahnemühle FineArt Baryta": 50,
      },

      frames: {
        Unframed: 0,

        "Black Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },

        "Natural Oak": {
          "12 × 16": 225,
          "16 × 20": 275,
          "20 × 24": 350,
          "24 × 30": 450,
        },
      },
    },
  },
];
